import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'antd';
import { NormalText } from '@Src/commons/StyledComponent';
import COLOR from '@Src/commons/Colors';
import { useParams } from 'react-router-dom';
import Spinner from '@Src/commons/Spinner';
import InvoiceCard from './InvoiceCard';
import ProductListing from './ProductListing';
import ReceiverDetails from './ReceiverDetails';
import { acceptGrn, formatData, getInvoiceDetails } from './utils';
import InvoiceAccepted from './InvoiceAccepted';
import InvoiceExpired from './InvoiceExpired';

type InitialGrnDataType = {
  document: File | null;
  receivedAt: string | null;
  comments: string | null;
};
type InvoiceDataType = {
  [key: string]: any;
};
const initialGrnData: InitialGrnDataType = {
  document: null,
  receivedAt: null,
  comments: null,
};
const initialErrorData = {
  title: 'Oops! Something went wrong.',
  message:
    'Invalid or expired redirection. Please check or request a new link.',
};
export default function InvoiceDetails() {
  const [status, setStatus] = useState('loading');
  const [isValidated, setValidation] = useState(false);
  const [invoiceData, setInvoiceData] = useState<InvoiceDataType>({});
  const [grnDetails, setGrnDetails] = useState(initialGrnData);
  const [btnLoading, setBtnLoading] = useState(false);
  const [error, setError] = useState(initialErrorData);
  const searchParams = new URLSearchParams(window.location.search);
  const requestToken = searchParams.get('token');
  const params: { id: string } = useParams();
  const invoiceId = params?.id;

  useEffect(() => {
    (async () => {
      setStatus('loading');
      if (requestToken && invoiceId) {
        getInvoiceDetails(requestToken, invoiceId)
          .then((response: any) => {
            if (response) {
              setInvoiceData(response);
              setStatus('pending');
            } else {
              setStatus('expired');
            }
          })
          .catch((err) => {
            setStatus('expired');
          });
      } else {
        setStatus('expired');
      }
    })();
  }, []);

  const submitGrn = () => {
    const data = formatData(requestToken, invoiceData, grnDetails);
    setBtnLoading(true);
    acceptGrn(data)
      .then(() => {
        setStatus('accepted');
        setBtnLoading(false);
      })
      .catch(() => {
        setBtnLoading(false);
      });
  };

  return (
    <div className="invoice-grn-acceptance">
      {status == 'pending' ? (
        <div className="align-items-center flex-column-direction pt-16 pl-24 pr-24 h-gap-24">
          <InvoiceCard status="pending" invoiceData={invoiceData} />
          <Row className="screen-width w-100">
            <Col>
              <NormalText
                color={COLOR.HIGH_EMPHASIS}
                fontSize={14}
                fontWeight={600}
              >
                {invoiceData?.documentDetails?.addItems?.items?.length}{' '}
                {invoiceData?.documentDetails?.addItems?.items?.length > 1
                  ? 'Products'
                  : 'Product'}
              </NormalText>
            </Col>
          </Row>
          <ProductListing invoiceData={invoiceData} />
          <Row className="screen-width w-100">
            <Col>
              <NormalText
                color={COLOR.HIGH_EMPHASIS}
                fontSize={14}
                fontWeight={600}
              >
                Receiver Details
              </NormalText>
            </Col>
          </Row>
          <ReceiverDetails
            setValidation={setValidation}
            setData={setGrnDetails}
            data={grnDetails}
            documentDate={invoiceData.documentDetails.invoiceData.documentDate}
          />
          <Row className="footer-width w-100 p-24 bottom-footer">
            <Button
              className="accept-grn-btn"
              type="primary"
              onClick={submitGrn}
              disabled={!isValidated}
              loading={btnLoading}
            >
              Accept Invoice
            </Button>
          </Row>
        </div>
      ) : status == 'accepted' ? (
        <InvoiceAccepted invoiceData={invoiceData} />
      ) : status == 'expired' ? (
        <InvoiceExpired error={error} />
      ) : (
        <Spinner className="whole-height" />
      )}
    </div>
  );
}
